function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import YouTubePopUpButton from "segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button";
import DefaultProps from "./default-props";
import { StyledSignupAndYoutubeComboButton } from "./signup-and-youtube-combo-button.scss";
class SignupAndYoutubeComboButton extends PureComponent {
    render() {
        const { youtubePopupButtonConfig, signupButtonConfig } = this.props;
        return /*#__PURE__*/ _jsxs(StyledSignupAndYoutubeComboButton, {
            className: "signup-and-youtube-combo-button",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "regular-button-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupButton, _object_spread({}, signupButtonConfig))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "secondary-button-wrapper",
                    children: /*#__PURE__*/ _jsx(YouTubePopUpButton, _object_spread({}, youtubePopupButtonConfig))
                })
            ]
        });
    }
}
export { SignupAndYoutubeComboButton as default };
SignupAndYoutubeComboButton.defaultProps = DefaultProps;
